import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "46px"
  }
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_footer_nav = _resolveComponent("footer-nav");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component
    }) => [_hoisted_1, (_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
    _: 1
  }), _createVNode(_Transition, {
    name: $data.navName
  }, {
    default: _withCtx(() => [$data.isShowNav ? (_openBlock(), _createBlock(_component_footer_nav, {
      key: 0,
      activeIndex: $data.activeIndex
    }, null, 8, ["activeIndex"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["name"])], 64);
}